import { Ntext } from "components";
import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";

const BlogTopPost = ({ state }) => {
  const [active, set_active] = useState(0);

  useEffect(() => {
    if (state?.top_articles?.length < 1) return;

    const timeout = setTimeout(() => {
      if (state?.top_articles?.length === active + 1) {
        set_active(0);
      } else {
        set_active(prev => prev + 1);
      }
    }, 5000);

    return () => {
      clearTimeout(timeout);
    };
  }, [active, state?.top_articles]);

  const current_top_article = state?.top_articles?.[active];

  const backgroundImageUrl = useMemo(() => {
    return `https://strapi.nomba.com${
      current_top_article?.cover?.url
    }?t=${new Date().getTime()}`;
  }, [current_top_article]);

  return state?.top_articles_loading ? (
    <div className="h-[480px] md:max-w-[1335px] mx-auto w-full animate-pulse rounded-[32px] bg-primary/10"></div>
  ) : (
    <section
      key={active}
      className="h-[480px] flex rounded-[32px] bg-[#0000007A] p-16 md:max-w-[1335px] mx-auto bg-no-repeat bg-center bg-cover"
      style={{
        background: `url(${backgroundImageUrl})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      <div className="w-full h-fit  mt-auto">
        <div className="px-4 py-1.5 border-2 rounded-full w-fit border-[#666666] bg-[#80808029] mb-4">
          <Ntext
            variant="p"
            className="!text-[14px] !leading-[20px] !text-white !font-semibold"
          >
            {current_top_article?.category?.name}
          </Ntext>
        </div>
        <div className="flex items-end justify-between mb-6">
          <div className="w-full max-w-[560px]">
            <Ntext
              className="!text-white !text-[32px] !leading-[40px] font-bold mb-2"
              variant="p"
            >
              {current_top_article?.title}
            </Ntext>
            <Ntext
              variant="p"
              className="!text-[16px] !leading-[20px] !text-white w-full h-[40px] overflow-hidden text-ellipsis whitespace-normal line-clamp-2"
            >
              {current_top_article?.description}
            </Ntext>
          </div>

          <div className="flex flex-col items-end gap-3">
            <div className="flex items-center gap-2">
              <img
                src={`https://strapi.nomba.com${current_top_article?.author?.avatar?.url}`}
                alt="author's image"
                className="border-[1.6px] border-[#E6E6E6] w-6 h-6 rounded-full"
              />{" "}
              <Ntext
                variant="p"
                className="!text-white !text-[16px] !leading-[24px] !font-bold"
              >
                {current_top_article?.author?.name}
              </Ntext>
            </div>
            <div className="flex items-center gap-3">
              <Ntext
                variant="p"
                className="!text-white !text-[16px] !leading-[24px] !font-medium"
              >
                {moment(current_top_article?.publishedAt).format(
                  "DD MMM. YYYY"
                )}
              </Ntext>
              <div className="w-1 h-1 rounded-full bg-[#999999]" />
              <Ntext
                variant="p"
                className="!text-white !text-[16px] !leading-[24px] !font-medium"
              >
                {current_top_article?.duration} min
                {current_top_article?.duration > 1 ? "s" : ""} read
              </Ntext>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-1">
          {state?.top_articles?.map((item, index) => (
            <div
              onClick={() => {
                set_active(index);
              }}
              role="button"
              key={item?.id}
              className={`w-3 h-3 border border-[#999999] rounded-full ${
                active === index ? "border-none bg-[#FFCC00]" : ""
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export { BlogTopPost };
